import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import { APPEAR_ANIMATION_DURATION } from '@modules/paint-picker-new/config';

export const Container: StyleRule = () => ({
    width: '100%',
    position: 'relative',
});

export const ColoursList: StyleRule = ({ theme }) => ({
    gridArea: 'main',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    gap: pxToRem(12),
    padding: pxArrayToRem([0, 0, 32, 0]),
    margin: 0,
    overflowX: 'scroll',

    // hide a scrollbar
    scrollbarWidth: 'none', // Firefox
    '&::-webkit-scrollbar': {
        // Webkit (Chrome, Safari, Edge)
        display: 'none',
    },
    '-ms-overflow-style': 'none', // IE and Edge

    [theme.screen.laptop]: {
        flexDirection: 'column',
        alignItems: 'center',
        maxHeight: pxToRem(560),
        overflowX: 'hidden',
        overflowY: 'scroll',
        padding: 0,

        '& > li:last-child': {
            marginBottom: pxToRem(12),
        },
    },
});

export const ColoursListElement: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',

    '&:first-child': {
        paddingLeft: pxToRem(16),
    },

    '&:last-child': {
        paddingRight: pxToRem(16),
    },

    [theme.screen.laptop]: {
        width: '100%',

        '&:first-child': {
            padding: 0,
        },

        '&:last-child': {
            padding: 0,
        },
    },
});

export const UsageHint: StyleRule = () => ({
    display: 'flex',
    position: 'absolute',
    top: pxToRem(16),
    left: pxToRem(140),
    background: '#272727',
    borderRadius: '8px',
    padding: pxArrayToRem([6, 10, 7, 16]),
    fontSize: pxToRem(16),
    lineHeight: pxToRem(26),
    letterSpacing: pxToRem(0.4),
    color: '#fff',
    whiteSpace: 'nowrap',

    '&::after': {
        content: '""',
        width: 0,
        height: 0,
        borderTop: `${pxToRem(10)} solid transparent`,
        borderBottom: `${pxToRem(10)} solid transparent`,
        borderRight: `${pxToRem(10)} solid #272727`,
        position: 'absolute',
        top: '50%',
        left: pxToRem(-8),
        transform: 'translateY(-50%)',
    },
});

export const colourListAnimation = {
    open: {
        minHeight: pxToRem(420),
        gap: pxToRem(12),
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
    closed: {
        minHeight: pxToRem(0),
        gap: pxToRem(9),
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
};

export const hintAnimation = {
    hintOn: {
        opacity: 1,
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
    hintOff: {
        opacity: 0,
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
    animate: {
        transform: ['translateX(0%)', 'translateX(5%)', 'translateX(0%)'],
        transition: {
            duration: 2,
            ease: 'easeInOut',
            repeat: Infinity,
        },
    },
};
